import { LightbulbAutoIcon } from './LightbulbAutoIcon';

/**
 * author: Michael Irigoyen
 * id DB38FD91-5875-4D53-81A9-A0B5400D53AE
 * name lightbulb-auto
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-auto.svg
 * tags
 * - Home Automation 
 */
export const LightbulbAutomaticIcon = LightbulbAutoIcon;
export default LightbulbAutomaticIcon